const initialState = {
    estado: 'NO_DEFINIDO',
    data: '',
    parametria:{},
    parametriaUvas:{
        montoMin:1000,
        montoMax:100000000,
        plazoMin:90,
        plazoMax:100000000
    }
  };

export const plazoFijoLandingPage = (state = initialState, action) => {
    
    switch (action.type) {
        case 'LANDING_PAGE':
            return {
                ...state,
                data: action.data
            }

        case 'SET_PARAMETRIA':
            return {
                ...state,
                parametria: action.data
            }

            
        case 'RESET_TO_INITIAL_STATE':
            return {
                ...initialState
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/plazoFijoLandingPage.js